import { useSettings } from '../../../Settings/SettingsProvider';
import React, { useState } from 'react';
import { useBaseLayerConfigs } from '../../../Settings/BaseMap/useBaseLayerConfigs';
import { useActivateBaseMapForm } from '../../../Settings/BaseMap/useActivateBaseMapForm';
import {
  Button,
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiMapTrifoldThin } from 'react-icons/pi';
import { CheckIcon } from '@radix-ui/react-icons';

export const BaseMaps = () => {
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const { baseLayerConfigs } = useBaseLayerConfigs();
  const { onSubmit } = useActivateBaseMapForm();
  const onBaseMapSelect = (active_base_map: string) => {
    if (active_base_map) {
      onSubmit({ active_base_map });
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              id="change-base-map-button"
              size="icon"
              variant="outline"
              className="h-10 w-10 flex-shrink-0 flex-grow-0"
            >
              <PiMapTrifoldThin className="size-5"></PiMapTrifoldThin>
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>Change base map</TooltipContent>
      </Tooltip>
      <PopoverContent>
        <Command>
          <CommandInput placeholder="Find base map..." />
          <CommandList>
            <CommandGroup heading="Base maps">
              {baseLayerConfigs.map((config) => (
                <CommandItem
                  key={config.id}
                  value={config.title}
                  onSelect={() => {
                    onBaseMapSelect(config.id);
                  }}
                >
                  <div className="flex justify-between w-full">
                    <div>{config.title}</div>
                    {settings['ribbonPlugin.settings'].active_base_map ===
                      config.id && <CheckIcon className="size-4" />}
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
